module.exports = __webpack_public_path__ + "static/btc-a552edcdd0b2c25ee26fe0d1fb222761.png";